<template>
  <div class="">
    <section class="service-area responsive-content responsive-content2 service--area case-page-2">
      <div class="think-fluid mt-100px">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="avivon-heading">
                <h2 class="avivon__title">
                  ¿Qué es el Buró de Entidades Financieras?
                </h2>
                <p style="text-align:justify" class="mt-40px mb-35px">
                    Es una herramienta de consulta y difusión con la que podrás conocer los productos que ofrecen las entidades financieras, sus comisiones y tasas, las reclamaciones de los usuarios, 
                    las prácticas no sanas en que incurren, las sansiones administrativas que les han impuesto, las cláusulas abusivas de sus contratos y otra información que resulte relevante 
                    para informarte sobre su desempeño. <br> <br>

                    Con el <router-link class="rg-a" to="" @click.native="redirectThirdSite('https://www.buro.gob.mx/', ThirdSiteText, true)">Buró de Entidades Financieras</router-link>, 
                    se logrará saber quién es quién en bancos, seguros, sociedades financieras de objeto múltiple, cajas de ahorro, afores, entre otras entidades.<br>

                    Con ello, podrás comparar y evaluar a las entidades financieras, sus productos y servicios y tendrás mayores elementos para elegir lo que te convenga.<br>

                    Esta información te será útil para elegir un producto financiero y también para conocer y usar mejor los que ya tienes. <br><br>

                    Este Buró de Entidades Financieras, es una herramienta que puede contribuir al crecimiento económico del país, al promover la competencia entre las instituciones financieras; 
                    que impulsará la transparencia al revelar información a los usuarios sobre el desempeño de éstas y los productos que ofrecen y que va a facilitar un manejo responsable de los productos y 
                    servicios financieros al conocer a detalle sus características. <br><br>

                    Lo anterior, podrá derivar en un mayor bienestar social, porque al conjuntar en un solo espacio tan diversa información del sistema financiero, el usuario tendrá más elementos para 
                    optimizar su presupuesto, para mejorar sus finanzas personales, para utilizar correctamente los créditos que fortalecerán su economía y obtener los seguros que la protejan, entre otros aspectos. <br><br>

                    El Buró de Entidades Financieras contiene información de <strong>Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo</strong> sobre nuestro desempeño frente a los Usuarios, 
                    por la prestación de productos y servicios. Te invitamos a consultarlo dando clic en la siguiente liga <router-link class="rg-a" to="" @click.native="redirectThirdSite('https://www.buro.gob.mx/', ThirdSiteText, true)"> https://www.buro.gob.mx/</router-link>.
                </p>

                <p style="text-align:justify" class="mt-40px mb-35px">
                  Consulta la información correspondiente a Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo en el Buró de Entidades Financieras.
                  <br>
                  <br>
                  <a class="rg-a" :href="uneReportUrl" target="_blank" rel="noopener noreferrer">Consultar</a>
                </p>
              </div>
            <!-- end avivon-heading -->
            </div><!-- end col-md-12 -->
          </div><!-- end row -->
        </div><!-- end container -->
      </div><!-- end think-fluid -->
    </section>
  </div>
</template>

<script>
export default {
  name: "FEArea1",
  data() {
    return {
      uneReportUrl: "https://cdn.redgirasol.com/informativos/UNE/BEF_IFC_RedGirasol_2410.pdf",
    };
  },
}
</script>
<style scoped>
</style>